import { getEnvValue, parseBoolean, parseNumber } from './utils'

export const SITE_YANDEX_MAP_API_KEY = getEnvValue('SITE_YANDEX_MAP_API_KEY')
export const SITE_AUTHORIZATION_TOKEN =
  getEnvValue('SITE_AUTHORIZATION_TOKEN') ?? ''

export const SITE_URL = getEnvValue('SITE_URL')
export const SEARCH_LANDING_SITE_URL = getEnvValue('SEARCH_LANDING_SITE_URL')
export const MKTU_LANDING_SITE_URL = getEnvValue('MKTU_LANDING_SITE_URL')

export const BRANDSIDE_SERVICE_URL = getEnvValue('BRANDSIDE_SERVICE_URL')

export const SITE_CALCULATOR = {
  taxForSubmitting: parseNumber('SITE_CALCULATOR_TAX_FOR_SUBMITTING'),
  mktuClassPrice: parseNumber('SITE_CALCULATOR_MKTU_CLASS_PRICE'),
  mktuWordPrice: parseNumber('SITE_CALCULATOR_MKTU_WORD_PRICE'),

  taxForIssuance: parseNumber('SITE_CALCULATOR_TAX_FOR_ISSUANCE'),
  mktuClassIssuancePrice: parseNumber(
    'SITE_CALCULATOR_MKTU_CLASS_ISSUANCE_PRICE'
  ),

  tariff: {
    SELF: parseNumber('SITE_CALCULATOR_TARIFF_SELF'),
    OPTIMAL: parseNumber('SITE_CALCULATOR_TARIFF_OPTIMAL'),
    ALL_INCLUSIVE: parseNumber('SITE_CALCULATOR_TARIFF_ALL_INCLUSIVE'),
    WITH_GUARANTEE: parseNumber('SITE_CALCULATOR_TARIFF_WITH_GUARANTEE'),
  },

  accelerated: {
    servicePrice: parseNumber('SITE_CALCULATOR_ACCELERATED_SERVICE_PRICE'),
    tax: {
      WORD: parseNumber('SITE_CALCULATOR_ACCELERATED_TAX_WORD'),
      IMAGE: parseNumber('SITE_CALCULATOR_ACCELERATED_TAX_IMAGE'),
      COMBINE: parseNumber('SITE_CALCULATOR_ACCELERATED_TAX_COMBINE'),
    },
  },
}

export const SITE_WITH_REVIEW_WIDGET = parseBoolean('SITE_WITH_REVIEW_WIDGET')
export const SITE_YANDEX_METRIKA = parseBoolean('SITE_WITH_YANDEX_METRIKA')
export const SITE_GOOGLE_TAG_MANAGER = parseBoolean(
  'SITE_WITH_GOOGLE_TAG_MANAGER'
)
export const SITE_CALLTOUCH = parseBoolean('SITE_WITH_CALLTOUCH')
export const SITE_AMO_METRIKA = parseBoolean('SITE_WITH_AMO_METRIKA')

export const SITE_YANDEX_METRIKA_COUNTER = getEnvValue(
  'SITE_YANDEX_METRIKA_COUNTER'
)

export const SITE_NEW_YEAR_THEME = parseBoolean('SITE_NEW_YEAR_THEME')

export const SITE_RECAPTCHA_KEY = getEnvValue('SITE_RECAPTCHA_KEY')

export const SITE_REVALIDATE_PAGE_INTERVAL = parseNumber(
  'PAGE_REVALIDATE_TIME',
  1800
)

export const NEXT_PUBLIC_MAX_BOT_URL = getEnvValue('MAX_BOT_URL')
